
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        selected: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['click'],
    setup(props, { emit }) {
        const onClick = () => {
            emit('click')
        }

        return {
            onClick
        }
    }
})
